export default __webpack_public_path__ + "static/media/wav.9d018586.svg";